import React from "react";
import PropTypes from "prop-types";
import FullScreenModal from "./FullScreenModal";
import { gql } from "apollo-boost";
import { graphql, compose } from "react-apollo";
import {
  getTransmittal,
  saveTransmittal,
  getTransmittalTemplate
} from "../api";
import ServiceAttachmentsQuery, {
  fragments
} from "../queries/ServiceAttachments";
import TransmittalEditorForm from "./TransmittalEditorForm";
import { addToCache } from "../utils/queryHelpers";

class TransmittalEditor extends React.Component {
  state = {
    loading: true,
    transmittal: {},
    template: {}
  };

  handleSubmit = values => {
    const { transmittalId } = this.props;
    return saveTransmittal(
      transmittalId && transmittalId !== "new" ? transmittalId : null,
      this.serializeTransmittal(values)
    )
      .then(
        response => {
          const { transmittal } = response;

          if (transmittalId !== "new") {
            return true;
          }

          return this.props.createAttachment({
            input: {
              name: this.state.template.name,
              attachmentType: "TRANSMITTAL",
              transmittalId: transmittal.id
            }
          });
        },
        err => {
          // TODO: Flash an alert
          console.error(err);
        }
      )
      .then(() => {
        this.props.close();
      });
  };

  loadTransmittal = () => {
    const { transmittalId, templateId } = this.props;
    if (transmittalId && transmittalId !== "new") {
      getTransmittal(transmittalId)
        .then(({ transmittal, transmittal_templates }) => {
          this.setState({
            loading: false,
            transmittal: transmittal,
            template: transmittal_templates[0]
          });
        })
        .catch(err => console.error("Error while fetching transmittal", err));
    } else if (templateId) {
      getTransmittalTemplate(templateId)
        .then(template => {
          this.setState({
            loading: false,
            template
          });
        })
        .catch(err =>
          console.error("Error while fetching transmittal template", err)
        );
    }
  };

  deserializeTransmittal = transmittal => {
    return {
      templateId: transmittal.template_id,
      transmittalData: transmittal.transmittal_data,
      structures: (transmittal.structures || []).map(structure => ({
        id: structure.id,
        transmittalData: structure.transmittal_data,
        templateId: structure.template_id
      }))
    };
  };

  serializeTransmittal = values => {
    return {
      template_id: this.state.transmittal.template_id || this.props.templateId,
      transmittal_data: values.transmittalData,
      structures: values.structures.map(structure => ({
        id: structure.id,
        transmittal_data: structure.transmittalData,
        template_id: structure.templateId
      }))
    };
  };

  componentDidMount() {
    this.loadTransmittal();
  }

  render() {
    if (this.state.loading) {
      return null;
    }

    if (this.state.template) {
      return (
        <FullScreenModal isOpen={true} close={this.props.close}>
          <TransmittalEditorForm
            editable={this.props.editable}
            template={this.state.template}
            cancel={this.props.close}
            onSubmit={this.handleSubmit}
            initialValues={{
              ...this.deserializeTransmittal(this.state.transmittal)
            }}
            style={{ paddingBottom: 80 }}
          />
        </FullScreenModal>
      );
    } else {
      this.props.close();
    }
  }

  static propTypes = {
    transmittalId: PropTypes.string,
    templateId: PropTypes.string,
    close: PropTypes.func.isRequired
  };
}

const CreateAttachmentMutation = gql`
  mutation CreateAttachment($input: AttachmentInput!) {
    createAttachment(input: $input) {
      ...ServiceAttachmentsAttachment
    }
  }
  ${fragments.attachment}
`;

const SmallServiceQuery = gql`
  query SmallServiceQuery($id: ID!) {
    service(id: $id) {
      id
      status
      locked
    }
  }
`;

const enhance = compose(
  graphql(SmallServiceQuery, {
    options: ({ serviceId }) => ({
      variables: { id: serviceId }
    }),
    props: ({ ownProps: { admin }, data: { loading, service } }) => ({
      editable: !loading && service && (admin || !service.locked)
    })
  }),
  graphql(CreateAttachmentMutation, {
    props: ({ ownProps: { serviceId }, mutate }) => ({
      createAttachment({ input }) {
        return mutate({
          variables: {
            input: {
              ...input,
              serviceId
            }
          },
          update: (store, { data: { createAttachment } }) => {
            addToCache(createAttachment, store, "attachments", {
              query: ServiceAttachmentsQuery,
              variables: { serviceId }
            });
          }
        });
      }
    })
  })
);

export default enhance(TransmittalEditor);



// WEBPACK FOOTER //
// ./src/components/TransmittalEditor.js